import NoData from '../../NoData';
import TimeSeriesChart, { TimeSeriesChartProps } from './TimeSeriesChart';

export interface EChartsWithDataProps extends TimeSeriesChartProps {
    error: string | null;
    loading: boolean;
    length: number;
}

export default function EChartsWithData(props: EChartsWithDataProps) {
    const { error, loading, length, ...chartProps } = props;

    if (!error && !loading && length > 0) {
        return <TimeSeriesChart {...chartProps}/>;
    }

    return <NoData error={error} loading={loading} length={length}/>;
}
